import React from 'react';
import styled from 'styled-components';
import Icon from './Icon';
import { Box } from './layout/Grid';

const Element = styled(Box)<{ isSelected: boolean }>`
  display: inline-flex;
  font-size: 14px;
  color: ${({ isSelected }) => (isSelected ? '#129EDC !important' : '#3c3c3c')};
  font-weight: ${({ isSelected }) => (isSelected ? '600' : '500')};
  cursor: pointer;
  transition:
    color 300ms ease-in,
    opacity 300ms ease-in;
  opacity: ${({ isSelected }) => {
    return isSelected ? 1 : 0.5;
  }};

  i {
    display: inline-flex;
    align-items: center;
    color: inherit;
    transition: transform 300ms ease-out;
    will-change: transform;
    transform: rotate(${({ isSelected }) => (isSelected ? 180 : 0)}deg);
  }

  span {
    color: inherit;
    margin-right: 5px;
  }

  &:hover {
    color: #000;
    transition: color 300ms ease-in;
  }
`;

const MenuItem = (props) => {
  return (
    <Element
      isSelected={props.isSelected}
      onClick={props.onClick}
      mr={[15, 15, 15, 26]}
    >
      <span>{props.children}</span>
      <Icon fontSize="7.5px" name="ygb-icon-chevron-down" />
    </Element>
  );
};

export default MenuItem;
